// This isn't really an error.
var RedirectException = function RedirectException(location, status) {
  if (status === void 0) {
    status = 302;
  }

  this.isFoundRedirectException = true;
  this.location = location;
  this.status = status;
};

export { RedirectException as default };